import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  IconButton,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function ChangeStatusModal({ open, onClose, data }) {
  const [newStatus, setNewStatus] = useState('');
  useEffect(() => {
    if (data) {
      setNewStatus(data.status);
    }
  }, [data]);

  const handleSave = () => {
    console.log(`Updating Service ID ${data?.id} to status: ${newStatus}`);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 3
        }}
      >
        Update Service Status
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ bgcolor: '#161C24', pt: 4, pb: 2 }}>
        <Box sx={{ mt: 3 }}>
          <FormControl fullWidth>
            <InputLabel sx={{ color: '#9CA3AF' }}>Select Status</InputLabel>
            <Select
              value={newStatus}
              label="Select Status"
              onChange={(e) => setNewStatus(e.target.value)}
              sx={{
                color: '#fff',
                '& fieldset': { borderColor: '#333' },
                '& .MuiSvgIcon-root': { color: '#9CA3AF' }
              }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="deleted">Deleted</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} sx={{ color: '#9CA3AF', textTransform: 'none' }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            bgcolor: '#3F90DF',
            px: 4,
            '&:hover': { bgcolor: '#005bbd' }
          }}
        >
          Save Status
        </Button>
      </DialogActions>
    </Dialog>
  );
}
